const ShadowBox: React.FC<{ children: JSX.Element }> = ({ children }) => {
  return (
    <div className="shadow-base py-5 px-8 rounded-[12px] bg-white">
      {children}
    </div>
  );
};

export default ShadowBox;
